import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconEyeClosed(props: IconProps) {
	return (
		<Icon stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" {...props}>
			<path d="M21 9c-2.4 2.667 -5.4 4 -9 4c-3.6 0 -6.6 -1.333 -9 -4" />
			<path d="M3 15l2.5 -3.8" />
			<path d="M21 14.976l-2.492 -3.776" />
			<path d="M9 17l.5 -4" />
			<path d="M15 17l-.5 -4" />
		</Icon>
	);
}
